import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NbThemeModule, NbLayoutModule, NbMenuModule, NbActionsModule, NbButtonModule, NbCardModule, NbContextMenuModule, NbDatepickerModule, NbDialogModule, NbIconModule, NbInputModule, NbSearchModule, NbSelectModule, NbSidebarModule, NbSpinnerModule, NbToastrModule, NbUserModule, NbIconLibraries } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { PageComponent } from './pages/page.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth-interceptor.service';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeFr);

const NB_MODULES = [
    NbLayoutModule,
    NbMenuModule,
    NbUserModule,
    NbActionsModule,
    NbSearchModule,
    NbSidebarModule,
    NbContextMenuModule,
    NbButtonModule,
    NbSelectModule,
    NbIconModule,
    NbEvaIconsModule,
    NbThemeModule.forRoot({ name: 'default' }),
    NbLayoutModule,
    NbEvaIconsModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDialogModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbCardModule,
    ReactiveFormsModule,
    NbInputModule,
    NbSpinnerModule,
    NbDateFnsDateModule.forRoot({ format: 'dd/MM/yyyy' }),
    NbToastrModule.forRoot()
];

@NgModule({
    declarations: [
        AppComponent,
        PageComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        NB_MODULES,
        NbLayoutModule,
        NbEvaIconsModule
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(private iconLibraries: NbIconLibraries) {
        this.iconLibraries.registerSvgPack('svg', {
            'picto_clients': '<svg id="Calque_2" data-name="Calque 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 19.5"><defs><style>.cls-1{fill:#4d4d4d;}</style></defs><g id="Calque_4" data-name="Calque 4"><path class="cls-1" d="M11.38,19.5s-1.62,0-1.62-1.62,1.62-6.5,8.12-6.5,8.12,4.88,8.12,6.5-1.62,1.62-1.62,1.62h-13ZM17.88,9.75c2.69,0,4.88-2.18,4.88-4.88S20.57,0,17.88,0s-4.88,2.18-4.88,4.88,2.18,4.88,4.88,4.88M8.48,19.5c-.24-.51-.36-1.06-.35-1.62,0-2.2,1.1-4.47,3.15-6.05-1.02-.31-2.08-.47-3.15-.45C1.62,11.38,0,16.25,0,17.88s1.62,1.62,1.62,1.62h6.85ZM7.31,9.75c2.24,0,4.06-1.82,4.06-4.06S9.56,1.62,7.31,1.62,3.25,3.44,3.25,5.69s1.82,4.06,4.06,4.06"/></g></svg>',
            'picto_dashboard': '<svg id="Calque_2" data-name="Calque 2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="10 8 40 40"><defs><style>.cls-1, .cls-2 {fill: #4d4d4d;}</style></defs><g id="Calque_4" data-name="Calque 4"><path class="cls-2" d="M31.21,16.57c.59,0,1.08.48,1.08,1.08v3.23c0,.59-.48,1.08-1.08,1.08s-1.08-.48-1.08-1.08v-3.23c0-.59.48-1.08,1.08-1.08M22.03,20.29c.42-.42,1.1-.42,1.52,0l1.97,1.97c.42.42.42,1.1,0,1.52s-1.1.42-1.52,0l-1.97-1.97c-.42-.42-.42-1.1,0-1.52M18.3,29.48c0-.59.48-1.08,1.08-1.08h3.41c.59,0,1.08.48,1.08,1.08s-.48,1.08-1.08,1.08h-3.41c-.59,0-1.08-.48-1.08-1.08M38.75,29.48c0-.59.48-1.08,1.08-1.08h3.23c.59,0,1.08.48,1.08,1.08s-.48,1.08-1.08,1.08h-3.23c-.59,0-1.08-.48-1.08-1.08M40.37,20.34c-.31-.31-.8-.33-1.13-.04l-8.99,7.69c-.83.7-.93,1.93-.24,2.76.7.83,1.93.93,2.76.24.1-.09.2-.18.28-.29l7.39-9.25c.27-.33.24-.81-.06-1.11h0Z"/><path class="cls-1" d="M14,29.48c0-9.51,7.72-17.21,17.23-17.2,9.51,0,17.21,7.72,17.2,17.23,0,1.94-.33,3.87-.97,5.7-.95,2.7-3.97,3.45-6.31,2.69-2.81-.91-6.76-1.96-9.93-1.96s-7.12,1.05-9.93,1.96c-2.34.76-5.36,0-6.31-2.69-.65-1.84-.98-3.78-.97-5.73M31.21,14.42c-8.32,0-15.06,6.74-15.07,15.06,0,1.71.29,3.4.86,5.02.44,1.24,1.99,1.89,3.62,1.36,2.84-.92,7.06-2.06,10.59-2.06s7.76,1.14,10.59,2.07c1.63.53,3.18-.12,3.62-1.36,2.77-7.84-1.35-16.45-9.19-19.22-1.61-.57-3.31-.86-5.02-.86"/></g></svg>',
            'picto_sav': '<svg id="Calque_2" data-name="Calque 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.8 26"><defs><style>.cls-1 {fill: #4d4d4d;}</style></defs><g id="Calque_4" data-name="Calque 4"><path class="cls-1" d="M10.4,1.73C5.61,1.73,1.73,5.61,1.73,10.4v1.73h1.73c.96,0,1.73.78,1.73,1.73v5.2c0,.96-.78,1.73-1.73,1.73h-1.73c-.96,0-1.73-.78-1.73-1.73v-8.67C0,4.66,4.66,0,10.4,0s10.4,4.66,10.4,10.4v10.4c0,2.39-1.94,4.33-4.33,4.33h-3.7c-.31.54-.88.87-1.5.87h-1.73c-.96,0-1.73-.78-1.73-1.73s.78-1.73,1.73-1.73h1.73c.62,0,1.19.33,1.5.87h3.7c1.44,0,2.6-1.16,2.6-2.6h-1.73c-.96,0-1.73-.78-1.73-1.73v-5.2c0-.96.78-1.73,1.73-1.73h1.73v-1.73c0-4.79-3.88-8.67-8.67-8.67"/></g></svg>',
            'picto_deconnexion': '<svg id="Calque_2" data-name="Calque 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.65 16.75"><defs><style>.cls-1 {fill: #4d4d4d;stroke: #4d4d4d;stroke-miterlimit: 10;stroke-width: .75px;}</style></defs><g id="Calque_4" data-name="Calque 4"><g><path class="cls-1" d="M9.28,15.87c0-.28.22-.5.5-.5h2.5c.55,0,1-.45,1-1V2.38c0-.55-.45-1-1-1h-2.5c-.28,0-.5-.22-.5-.5,0-.28.22-.5.5-.5h2.5c1.1,0,2,.9,2,2v12c0,1.1-.9,2-2,2h-2.5c-.28,0-.5-.22-.5-.5"/><path class="cls-1" d="M.52,8.73c-.2-.2-.2-.51,0-.71,0,0,0,0,0,0l3-3c.2-.2.51-.2.71,0s.2.51,0,.71l-2.15,2.15h8.79c.28,0,.5.22.5.5,0,.28-.22.5-.5.5H2.08s2.15,2.15,2.15,2.15c.2.2.2.51,0,.71s-.51.2-.71,0l-3-3Z"/></g></g></svg>',
        });
    }
}